(function () {
  function init(root) {
    if (!root || root.dataset.pxcReady === 'true') return;
    root.dataset.pxcReady = 'true';

    var form = root.querySelector('[data-pxc-filter-form]');
    var sort = root.querySelector('[data-pxc-sort]');
    if (form && sort) sort.addEventListener('change', function () { form.submit(); });

    root.querySelectorAll('.pxc-filter').forEach(function (filter) {
      filter.addEventListener('toggle', function () {
        if (!filter.open) return;
        root.querySelectorAll('.pxc-filter[open]').forEach(function (other) {
          if (other !== filter) other.removeAttribute('open');
        });
      });
    });

    var drinkFilter = root.querySelector('[data-pxc-drink-filter]');
    if (drinkFilter) {
      var drinkButtons = Array.prototype.slice.call(drinkFilter.querySelectorAll('[data-pxc-drink-value]'));
      var productCards = Array.prototype.slice.call(root.querySelectorAll('.pxc-grid > .pxc-card'));
      var drinkCount = drinkFilter.querySelector('[data-pxc-drink-count]');

      // Independent manual collection order for every drink on the All Cups page.
      // Keep other landing pages' existing filters and content unchanged.
      var remoteEnabled = /\/collections\/tassen\/?$/.test(window.location.pathname);
      var drinkCollections = {
        all: 'tassen',
        ristretto: 'ristretto',
        espresso: 'espressotassen',
        doppio: 'doppio',
        cortado: 'cortado',
        lungo: 'lungo',
        cappuccino: 'cappuccino-tassen',
        'flat-white': 'flat-white',
        tee: 'tee'
      };
      var grid = root.querySelector('.pxc-grid');
      var originalNodes = grid ? Array.prototype.slice.call(grid.childNodes) : [];
      var originalPagination = root.querySelector('.pxc-pagination');
      var paginationWasHidden = originalPagination ? originalPagination.hidden : false;
      var remotePagination = null;
      var requestVersion = 0;
      var controller = null;
      var remoteActive = false;
            var remoteEnabled = /\/collections\/(?:tassen|espressotassen|cappuccino-tassen)\/?$/.test(window.location.pathname);      var collectionBase = window.location.pathname.replace(/collections\/(?:tassen|espressotassen|cappuccino-tassen)\/?$/, 'collections/');

      function resetRemote() {
        requestVersion += 1;
        if (controller) controller.abort();
        if (remoteActive && grid) grid.replaceChildren.apply(grid, originalNodes);
        remoteActive = false;
        if (remotePagination) remotePagination.remove();
        remotePagination = null;
        if (originalPagination) originalPagination.hidden = paginationWasHidden;
        if (grid) grid.removeAttribute('aria-busy');
      }

      function loadCollection(handle, label, page) {
        if (!grid) return;
        if (controller) controller.abort();
        controller = new AbortController();
        var currentController = controller;
        var version = ++requestVersion;
        var timeout = window.setTimeout(function () { currentController.abort(); }, 12000);
        var url = new URL(collectionBase + handle, window.location.origin);
        url.searchParams.set('view', 'px-drink-grid');
        url.searchParams.set('sort_by', 'manual');
        url.searchParams.set('page', String(page || 1));
        grid.setAttribute('aria-busy', 'true');
        if (drinkCount) drinkCount.textContent = label + ' wird geladen …';
        if (originalPagination) originalPagination.hidden = true;
        fetch(url.toString(), { signal: currentController.signal, credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Collection request failed');
            return response.text();
          })
          .then(function (html) {
            if (version !== requestVersion || !root.isConnected) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var result = doc.querySelector('[data-pxc-remote-grid]');
            var cards = result && result.querySelector('[data-pxc-remote-cards]');
            var total = result ? Number(result.dataset.total) : NaN;
            if (!cards || result.dataset.collection !== handle || !Number.isInteger(total) || total < 0) throw new Error('Invalid collection grid');
            grid.replaceChildren.apply(grid, Array.prototype.slice.call(cards.childNodes));
            remoteActive = true;
            if (remotePagination) remotePagination.remove();
            remotePagination = result.querySelector('[data-pxc-remote-pagination]');
            if (remotePagination) {
              grid.insertAdjacentElement('afterend', remotePagination);
              // Modified clicks must open a real collection page, not the HTML fragment.
              remotePagination.querySelectorAll('a').forEach(function (link) {
                var destination = new URL(link.href, window.location.origin);
                destination.searchParams.delete('view');
                destination.searchParams.set('sort_by', 'manual');
                link.href = destination.toString();
              });
              remotePagination.addEventListener('click', function (event) {
                var link = event.target.closest('a');
                if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                event.preventDefault();
                var next = new URL(link.href, window.location.origin);
                loadCollection(handle, label, Number(next.searchParams.get('page')) || 1);
              });
            }
            if (drinkCount) drinkCount.textContent = total + (total === 1 ? ' passendes Set' : ' passende Sets');
          })
          .catch(function () {
            if (version !== requestVersion || !root.isConnected) return;
            // Keep usable local cards (or the previous remote page) and offer a retry.
            if (drinkCount) drinkCount.textContent = label + ' konnte nicht geladen werden. Bitte den Button erneut wählen.';
            if (!remoteActive && originalPagination) originalPagination.hidden = paginationWasHidden;
          })
          .finally(function () {
            window.clearTimeout(timeout);
            if (version === requestVersion) grid.removeAttribute('aria-busy');
          });
      }

      drinkButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var selected = button.dataset.pxcDrinkValue;
          var visibleCount = 0;
          if (remoteEnabled) resetRemote();

          drinkButtons.forEach(function (other) {
            var active = other === button;
            other.classList.toggle('is-active', active);
            other.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          productCards.forEach(function (card) {
            var styles = (card.dataset.pxcDrinkStyles || '').split(/\s+/);
            var visible = selected === 'all' || styles.indexOf(selected) !== -1;
            card.hidden = !visible;
            if (visible) visibleCount += 1;
          });

          if (drinkCount) drinkCount.textContent = visibleCount + (visibleCount === 1 ? ' passendes Set' : ' passende Sets');
          if (remoteEnabled && Object.prototype.hasOwnProperty.call(drinkCollections, selected)) {
            loadCollection(drinkCollections[selected], button.textContent.trim(), 1);
          }
        });
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.pxc-products').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
